resetStoreCallbacks